<template>
    <div class="search-control">
        <!-- 搜索组件 -->
        <UiIcon name="search" class="search-icon" @click="searchVisible = !searchVisible" />

        <!-- 搜索窗口 -->
        <Transition @enter="entranceAnimation" @leave="departureAnimation" @before-enter="entrancePreAnimation">
            <div class="search-window" ref="searchWindowNode" v-show="searchVisible" @click.self="searchVisible = false" @wheel.stop>
                <div class="control-container" ref="searchNode">
                    <!-- * 搜索框 -->
                    <div class="container">
                        <select-search v-model="keyword" @search="methods.search" :style="'style2'" :navigation="true"></select-search>
                    </div>
                    <!-- 热门基因 -->
                    <div class="control-hots container" v-if="data && data.length">
                        <template v-for="(value, index) in data" :key="index">
                            <ProjectRoute class="control-hot" :to="methods.route(value)">
                                {{ value.value }}
                            </ProjectRoute>
                        </template>
                    </div>
                </div>
            </div>
        </Transition>
    </div>
</template>

<script lang="ts" setup>
//* 组件库
import { UiIcon } from "various-ui";
import { SelectSearch } from "@/components/controls";
//* 组件属性
import type { HotOption } from "./src/types";
import { useComposable } from "./src/composable";

//* 获取热门搜索列表
const data: Ref<HotOption[]> = await api.server("HomeHots", "/api/v1/home/hots");

const { refs, watchs, methods } = useComposable();
const { keyword, searchNode, searchVisible, searchWindowNode } = refs;
const { entranceAnimation, departureAnimation, entrancePreAnimation } = methods;

onBeforeUnmount(() => {
    watchs.stop && watchs.stop();
    watchs.stopWheel && watchs.stopWheel();

    document.body.style.overflow = "";
});
</script>

<style lang="less" scoped>
@import url("./style/index.less");
</style>

<style lang="less">
.windows-search-candidates {
    width: 764px;
    transform: translateY(-9px) !important;
    border-radius: 0 0 var(--uioption-form-radius) var(--uioption-form-radius);

    .ui-form-candidates-triangle {
        display: none;
    }

    .ui-form-candidate {
        display: flex;
        padding: 0 24px;
        align-items: center;

        .ui-icon {
            font-size: 16px;
            margin-right: 16px;
        }

        .ui-gene-icon {
            color: var(--ui-gene-color);
        }

        .ui-model-icon {
            color: var(--ui-model-color);
        }

        .ui-disease-icon {
            color: var(--ui-disease-color);
        }

        .name {
            flex-shrink: 0;
            margin-right: 24px;
            width: 176px;
        }

        .alias {
            span {
                color: #ce2424;
            }
        }
    }

    .ui-form-candidate.ui-active,
    .ui-form-candidate:hover {
        background: var(--uicolor-font-5) !important;
        color: var(--uicolor-font-1) !important;
    }
}

.windows-search-candidates::before {
    background-color: var(--uicolor-font-4-05);
    position: absolute;
    content: "";
    height: 1px;
    width: calc(100% - 48px);
    top: 0;
    left: 24px;
}
</style>
